/**
 * Centralized registration dates for MonegrosBook 2026.
 * All updates here will reflect across all components (Home, Inscription, Manual, etc.)
 */

export const REGISTRATION_DATES = {
    PRE_START: new Date("2026-01-20T10:00:00"),
    INSCRIPTION_START: new Date("2026-02-06T21:00:00"),
    CLOSING_DATE: new Date("2026-10-21T23:59:00"),
    /** Temporary reopening of inscriptions (banner shown until this moment). */
    REOPENING_DATE: new Date("2026-09-16T21:00:00"),
};

/**
 * Returns the current registration phase based on system time.
 */
export function getRegistrationPhase(): "pre" | "inscription" | "closed" {
    const now = new Date();
    if (now >= REGISTRATION_DATES.CLOSING_DATE) return "closed";
    if (now >= REGISTRATION_DATES.INSCRIPTION_START) return "inscription";
    return "pre";
}

/**
 * Helper to check if registration is currently closed.
 */
export function isRegistrationClosed(): boolean {
    const now = new Date();
    return now >= REGISTRATION_DATES.CLOSING_DATE;
}

/**
 * Whether the "Reabrimos inscripciones" banner should be visible
 * (only until the reopening moment).
 */
export function isBeforeReopening(): boolean {
    return new Date() < REGISTRATION_DATES.REOPENING_DATE;
}
